<template>
  <div class="view-profile container">
    <div class="center">
      <h4 class="cyan-text text-darken-1">プロフィール</h4>
      <h5 v-if="profile" class="grey-text text-darken-1">{{ profile.alias }}</h5>
    </div>
  </div>
</div>
</template>

<script>
import db from '@/firebase/init'

export default{
  name: 'ViewProfile',
  data(){
    return{
      profile: null,
      alias: null
      }
    },
    created(){
      let ref = db.collection('users')
      ref.doc(this.$route.params.id).get()
      .then(user => {
        this.profile = user.data()
      })
    }
  }
</script>

<style>

h4{
 margin-top: 50px;
}



</style>



// WEBPACK FOOTER //
// src/components/profile/ViewProfile.vue